import i18n from '@i18n';

export const SELECT_HIDDEN_OPTIONS = [
  { value: true, label: i18n.t(`modal.showHidden`) },
  { value: false, label: i18n.t(`modal.showVisible`) },
];
